// src/components/providers/StoreProvider.tsx
"use client";

import { useRef } from "react";
import { useAppStore, getInitialState, type AppData } from "@/store/appStore";

// Props for hydrating store on client
type StoreProviderProps = {
	children: React.ReactNode;
	initialState?: Partial<AppData>;
};

const StoreProvider = ({ children, initialState }: StoreProviderProps) => {
	const initialized = useRef<boolean>(false);

	// Initialize store with server data if available
	if (!initialized.current && initialState) {
		useAppStore.setState({
			data: { ...getInitialState(), ...initialState },
		});
		initialized.current = true;
	}

	return <div>{children}</div>;
};

export default StoreProvider;
